module.exports = __webpack_public_path__ + "img/registration-01.fde5b4e3.png";